'use strict';

var React = require('react');

var SvgFolderAddIcon = function SvgFolderAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5a2.75 2.75 0 0 1-2.75-2.75v-6.5a2.75 2.75 0 0 1 2.75-2.75h1.514a2.75 2.75 0 0 1 2.46 1.52l.17.342a.25.25 0 0 0 .224.138h4.132a2.75 2.75 0 0 1 2.75 2.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25h-4.132a1.75 1.75 0 0 1-1.565-.967l-.171-.342a1.25 1.25 0 0 0-1.118-.691h-1.514Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14.5a.75.75 0 0 1 .75-.75h1v-1a.75.75 0 0 1 1.5 0v1h1a.75.75 0 0 1 0 1.5h-1v1a.75.75 0 0 1-1.5 0v-1h-1a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgFolderAddIcon.displayName = "FolderAddIcon";

exports.SvgFolderAddIcon = SvgFolderAddIcon;
